import ListProduct from './ListProduct.view';

export default ListProduct;
